module.exports = __webpack_public_path__ + "static/media/history_8.c18a3a9b.jpg";